import type { ChargerTileMv } from "../types/dashboard";

/** Default fleet-power scale γ when server store is unavailable. */
export const POWER_GAMMA_DEFAULT = 1.5;

export const CHARGER_POWER_SAMPLE_MS = 1000;

export const CHARGER_POWER_RANGES = ["1m", "5m", "15m", "1h", "6h", "24h", "7d", "all"] as const;
export type ChargerPowerRange = (typeof CHARGER_POWER_RANGES)[number];
export const CHARGER_POWER_DEFAULT_RANGE: ChargerPowerRange = "1h";

export function sumTilesPowerW(tiles: Record<string, ChargerTileMv> | undefined): number {
  if (!tiles) return 0;
  let total = 0;
  for (const tile of Object.values(tiles)) {
    const w = tile.power_current_w;
    if (w != null && Number.isFinite(w) && w > 0) total += w;
  }
  return total;
}

export function fleetPowerTotalW(
  connectedChargers:
    | { power_total_w?: number; tiles?: Record<string, ChargerTileMv> }
    | null
    | undefined,
): number | null {
  if (!connectedChargers) return null;
  const fromServer = connectedChargers.power_total_w;
  if (fromServer != null && Number.isFinite(fromServer)) return fromServer;
  if (connectedChargers.tiles) return sumTilesPowerW(connectedChargers.tiles);
  return null;
}

export function chargerPowerRangeToMs(range: ChargerPowerRange): number | null {
  switch (range) {
    case "1m":
      return 60 * 1000;
    case "5m":
      return 5 * 60 * 1000;
    case "15m":
      return 15 * 60 * 1000;
    case "1h":
      return 60 * 60 * 1000;
    case "6h":
      return 6 * 60 * 60 * 1000;
    case "24h":
      return 24 * 60 * 60 * 1000;
    case "7d":
      return 7 * 24 * 60 * 60 * 1000;
    case "all":
      return null;
  }
}
